import { FC } from 'react';
import { CommonIconProps } from 'src/components/Icons/commonIconProps';

type Props = CommonIconProps;

export const IconStartGuide: FC<Props> = ({ className }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      /* eslint-disable-next-line max-len */
      d="M5.5 19.1667C5.22386 19.1667 5 18.9428 5 18.6667L5 2.44637C5 1.7042 5.78 1.22064 6.44473 1.55071L15.7288 6.16062C16.4631 6.52524 16.4707 7.57005 15.7418 7.94535L6.5 12.7037V18.6667C6.5 18.9428 6.27614 19.1667 6 19.1667H5.5ZM6.5 10.758L14.5 7.04011L6.5 3.3222V10.758Z"
      fill="#625EE9"
    />
  </svg>
);
